import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DateTime } from 'luxon';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { CalculationTimeAndAttendanceDto, CommonCacheServiceProxy, UserWorkDaySettingCreateOrEditDto } from '../../../../../shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { DashboardUserTimeDataService } from '../dashboard-user-time-data.service';
import { Subscription } from 'rxjs';
@Component({
    standalone: false,
    selector: 'app-user-timecardsinfo',
    templateUrl: './user-timecardsinfo.component.html',
    styleUrls: ['./user-timecardsinfo.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserTimecardsinfoComponent extends AppComponentBase implements OnInit, OnDestroy {
    leavesCards = [
        { id: 1, name: 'ArrivalTime', price: '09:30 hours', icon: 'assets/common/images/photos/Dashboard_ArrivalTime.svg', class: 'ArrivalText' },
        { id: 2, name: 'LeftTime', price: 'ONLINE', icon: 'assets/common/images/photos/Dashboard_LeftTime.svg', class: 'leftTImetext' },
        { id: 3, name: 'ProductiveTime', price: '09:30 hours', icon: 'assets/common/images/photos/Dashboard_ProductionTime.svg', class: 'ArrivalText' },
        { id: 4, name: 'ActiveTime', price: '09:30 hours', icon: 'assets/common/images/photos/Dashboard_InTimePro.svg', class: 'leftTImetext' },
        { id: 5, name: 'TimeAtWork', price: '09:30 hours', icon: 'assets/common/images/photos/Dashboard_TimeAtWork.svg', class: 'ArrivalText' },
        { id: 6, name: 'PlaceInGroup', price: '3rd', icon: 'assets/common/images/photos/Dashboard_PlacesinGroup.svg', class: 'ArrivalText' },
        { id: 7, name: 'Effectiveness', price: '80%', icon: 'assets/common/images/photos/Dashboard_Effectiveness.svg', class: 'ArrivalText' },
        { id: 8, name: 'Productivity', price: '80%', icon: 'assets/common/images/photos/Dashbaord_Productivity.svg', class: 'ArrivalText' }
    ];
    isLoaded = false;
    isEmpty = true;
    currentTimeAtWork;
    currentActiveTime;
    currentEffectiveness;
    currentProductiveTime: number = 4;
    currentProductivity;
    workStartTempTime: Date;
    workEndTempTime: Date;
    timeDifference: string = '';
    userWorkDaySetting = new UserWorkDaySettingCreateOrEditDto();
    userId: number = 0;
    max: number = 100;
    stroke: number = 5;
    radius: number = 60;
    semicircle: boolean = false;
    rounded: boolean = false;
    responsive: boolean = false;
    clockwise: boolean = true;
    color: string = '#9B0B53'; //'#45ccce';
    background: string = '#eaeaea';
    duration: number = 800;
    animation: string = 'easeOutCubic';
    animationDelay: number = 0;
    gradient: boolean = false;
    realCurrent: number = 0;
    lateByTime;
    leftByTime;
    leftOnTime: boolean = false;
    getOverlayStyle() {
        const isSemi = this.semicircle;
        const transform = (isSemi ? '' : 'translateY(-50%) ') + 'translateX(-50%)';
        return {
            top: isSemi ? 'auto' : '52%',
            bottom: isSemi ? '5%' : 'auto',
            left: '52%',
            transform,
            'font-size': this.radius / 3.5 + 'px',
        };
    }
    myDate = new Date();
    productivityPercentage: any;
    private userTimeDetailsSubscription: Subscription;
    constructor(private _abpUserService: AbpSessionService, private _commonCacheServiceProxy: CommonCacheServiceProxy, private _dashboardUserTimeDataService: DashboardUserTimeDataService, injector: Injector) {
        super(injector);
    }
    userData = new CalculationTimeAndAttendanceDto();
    ngOnInit(): void {
        this.userTimeDetailsSubscription = this._dashboardUserTimeDataService.userTimeDetails$.subscribe((data) => {
            this.getUserTimedetails(data)
            this.markForCheck();
        });
    }
    ngOnDestroy(): void {
        this.userTimeDetailsSubscription?.unsubscribe();
    }
    EarlyBy = false;
    LateBy = false;
    EarlyByTime;
    onTime = false;
    getUserTimedetails(result: CalculationTimeAndAttendanceDto) {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        this.userData = result;
        this.productivityPercentage = result.productivityPercentage;
        this.isLoaded = true;
        this.isEmpty = false;
        let workingHours = Math.floor(parseInt(this.userData.timeAtWork.split(":")[0]));
        let workingMin = parseInt(this.userData.timeAtWork.split(":")[1]);
        let totalMinutes = workingHours * 60 + workingMin;
        totalMinutes = (totalMinutes / this.userData.minimumUsererWorkingHours) * 100;
        if (totalMinutes) {
            this.currentTimeAtWork = Math.floor(totalMinutes) == 100 || Math.floor(totalMinutes) > 100 ? 100 : Math.floor(totalMinutes);
        }
        else {
            this.currentTimeAtWork = 0;
        }
        let activeHours = Math.floor(parseInt(this.userData.trackedTime.split(":")[0]));
        let activeMin = parseInt(this.userData.trackedTime.split(":")[1]);
        let activeTotalMinutes = activeHours * 60 + activeMin;
        activeTotalMinutes = (activeTotalMinutes / this.userData.minimumUsererWorkingHours) * 100;
        this.currentActiveTime = activeTotalMinutes ? Math.min(Math.round(activeTotalMinutes), 100) : 0;
        let arrivalTimeTemp = this.userData.arrivalTime;
        let arrivalJSDate = arrivalTimeTemp?.toJSDate();
        let workStartTimeTemp = this.userData.workStartDate;
        let workStartTimeJSDate = workStartTimeTemp.toJSDate();
        let arrivalMinut = Number(arrivalJSDate.getHours() * 60 + arrivalJSDate.getMinutes());
        let startTotalMin = Number(workStartTimeJSDate.getHours() * 60 + workStartTimeJSDate.getMinutes());
        let finalMin = arrivalMinut > startTotalMin ? arrivalMinut - startTotalMin : startTotalMin - arrivalMinut;
        let arrivalHours = (finalMin) / 60;
        arrivalHours = arrivalHours > 1 ? arrivalHours : 0;
        var min = (finalMin) % 60;
        var t = min < 10 ? "0" + min : min.toString();
        var hr = arrivalHours < 10 ? "0" + (finalMin / 60).toString().split('.')[0] : (finalMin / 60).toString().split('.')[0];
        this.lateByTime = hr + ':' + t;
        if (arrivalMinut < startTotalMin) {
            this.EarlyBy = true;
            this.LateBy = false;
            this.EarlyByTime = this.lateByTime;
        }
        else if (arrivalMinut == startTotalMin) {
            this.EarlyBy = false;
            this.LateBy = false;
            this.onTime = true;
        }
        else {
            this.LateBy = true;
            this.EarlyBy = false;
        }
        if (this.userData.leftDateTime != null) {
            let leftTimeTemp = this.userData.leftDateTime;
            let leftTimeJSDate = leftTimeTemp.toJSDate();
            let workEndTimeTemp = this.userData.workEndDate;
            let workEndTimeJSDate = workEndTimeTemp.toJSDate();
            var h = workEndTimeJSDate.getHours() - leftTimeJSDate.getHours();
            var totalleftminute = (h * 60);
            if (leftTimeJSDate.getMinutes() > workEndTimeJSDate.getMinutes()) {
                totalleftminute -= leftTimeJSDate.getMinutes() - workEndTimeJSDate.getMinutes();
                this.EarlyBy = true;
                this.leftOnTime = false;
            }
            else if (leftTimeJSDate.getHours() === workEndTimeJSDate.getHours() &&
                leftTimeJSDate.getMinutes() === workEndTimeJSDate.getMinutes()) {
                totalleftminute += 0;
                this.LateBy = true;
                this.leftOnTime = false;
            }
            else {
                totalleftminute += workEndTimeJSDate.getMinutes() - leftTimeJSDate.getMinutes();
                this.leftOnTime = false;
                this.EarlyBy = false;
            }
            var min1 = (totalleftminute) % 60;
            var t1 = min1 < 10 ? "0" + min1 : min1.toString();
            var hr1 = h < 10 ? "0" + (totalleftminute / 60).toString().split('.')[0] : (totalleftminute / 60).toString().split('.')[0];
            this.leftByTime = hr1 + ':' + t1;
            this.leftByTime = (totalleftminute) / 60 < 0 ? '00:00' : this.leftByTime;
        }
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    getMeridian(date: DateTime) {
        if (!date)
            return '-';
        return date.hour <= 12 ? 'AM' : 'PM';
    }
    getLocalJsDate(date: DateTime): Date | null {
        if (!date || (date.hour == 0 && date.minute == 0)) {
            return null;
        }

        const jsDate = new Date(
            `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}` +
            `T${date.hour < 10 ? '0' + date.hour : date.hour}:${date.minute < 10 ? '0' + date.minute : date.minute}:00`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    hasDisplayableArrivalTime(date: DateTime): boolean {
        return !!date && (date.hour > 0 || date.minute > 0);
    }
    getTrimmedPercentage(value: number) {
        if (value == 0 || value == null) {
            return '0.0';
        }
        else if (value) {
            return value.toFixed(1);
        }
    }
    getHrsAndMinutes(timestamp: string) {
        if (!timestamp)
            return '00h 00m';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min}`;
    }
    getUserWorkingDaySetting() {
        this._commonCacheServiceProxy.getUserWorkDaySettingForEdit(this._abpUserService.tenantId, this._abpUserService.userId).subscribe(res => {
            if (res.id !== undefined)
                this.userWorkDaySetting = res;
            if (res.workStartDate !== undefined)
                this.workStartTempTime = res.workStartDate.toJSDate();
            if (res.workEndDate !== undefined)
                this.workEndTempTime = res.workEndDate.toJSDate();
            this.markForCheck();
        });
    }
}
